module.exports = __webpack_public_path__ + "static/media/table-lock.48129479.svg";